import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Research from '@/components/Research'
import People from '@/components/People'
import Science from '@/components/Science'
import Joinus from '@/components/Joinus'
import Contactus from '@/components/Contactus'

// const Research = () => import('../components/Research')
// const People = () => import('../components/People')
// const Science = () => import('../components/Science')
// const Joinus = () => import('../components/Joinus')
// const Contactus = () => import('../components/Contactus')

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err);
}

Vue.use(Router)

export default new Router({
  mode: "history",
  routes: [
   {path:'/',redirect:{name:"Index"}},
    {
      path: '/',
      name: 'Index',
      component: Index
    },
    {
      path: '/Research',
      name: 'Research',
      component: Research
    },
    {
      path: '/People',
      name: 'People',
      component: People
    },
    {
      path: '/Science',
      name: 'Science',
      component: Science
    },
    {
      path: '/Joinus',
      name: 'Joinus',
      component: Joinus
    },
    {
      path: '/Contactus',
      name: 'Contactus',
      component: Contactus
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js